import { Dialog } from '@ori-ui/components';
import { Component } from 'react';

interface ErrorBoundaryProps {
  children: JSX.Element;
}

interface ErrorBoundaryState {
  error?: Error;
  open: boolean;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  override readonly state: ErrorBoundaryState = { open: false };

  static getDerivedStateFromError(error: Error) {
    return { error, open: true };
  }

  handleOnClose = () => this.setState({ open: false });

  override render() {
    const { error, open } = this.state;

    if (error) {
      return (
        <Dialog
          open={open}
          header="Ooops... error found :("
          size="small"
          onClose={this.handleOnClose}
        >
          <pre>{error.message}</pre>
        </Dialog>
      );
    }

    const { children } = this.props;

    return children;
  }
}
